<template>
    <div>
       <checkbox-input :name="name" :label="label" :items="filteredUsers" :checked="checked" :dimension="dimension" :error="phpError" for-else-message="No users available"></checkbox-input>
    </div>
</template>

<script>
import CheckboxInput from './Inputs/CheckboxInputUser.vue';
import { EventBus } from '../event-bus.js';

export default {
    components: {
        CheckboxInput,
    },
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '', required: false },
        userOptions: { type: Array, default: [], required: false},
        checked: { type: Array, default: [], required: false },
        brandId: { type: Number, default: 0, required: false },
        dimension: { type: String, default: 'horizontal', required: false},
        phpError: { type: String, default: '', required: false },
        countryValue: { type:Number, required: true }
    },
    data() {
        return {
            'users': this.userOptions,
            'filteredUsers': [],
        }
    },
    mounted() {
        this.filteredUsers = this.filterOnBrandId(this.brandId);
    },
    created() {
        EventBus.$on('brand-changed-allowed-users', (name, value) => {
            this.filteredUsers = this.filterOnBrandId(Number(value));
        });

        EventBus.$on('brand-added-allowed-users', (name, value) => {
            let params = {
                country_value: this.countryValue
            };
            axios.get('/api/users', { params }).then(response => {
                this.users = response.data.users;
                this.filteredUsers = this.filterOnBrandId(Number(value));
            }).catch(error => {
                this.filteredUsers = this.filterOnBrandId(Number(value));
            });
        });
    },
    beforeDestroy() {
        EventBus.$off('brand-changed-allowed-users');
        EventBus.$off('brand-added-allowed-users');
    },
    methods: {
        filterOnBrandId(id) {
            return this.users.filter((user) => {
                return user.role == 1 || user.brands.some((brand) => brand.id === id );//role == 1 => admin user
            });
        },
    },
}
</script>